import {skipToken} from '@reduxjs/toolkit/query';

import {isNil} from 'ramda';

import {useGetServiceOrderVariantIntegrationQuery} from '@dms/api/workshop';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

import {useIntegrationsEnabled} from '../../../hooks/useIntegrationsEnabled';
import {JobSegments} from '../../../types/JobSegments';

interface UseJobXentryAdditionalInformationProps {
  serviceCaseId: string;
  orderId: string | Nullish;
  serviceOrderVariantId: string | Nullish;
  requestedSegment: JobSegments;
}

export function useJobXentryAdditionalInformation(props: UseJobXentryAdditionalInformationProps) {
  const {isDaimlerXentryIntegrationEnabled} = useIntegrationsEnabled({
    serviceCaseId: props.serviceCaseId,
  });

  const {data: serviceOrderVariantIntegration} = useGetServiceOrderVariantIntegrationQuery(
    isDaimlerXentryIntegrationEnabled && isNotNilOrEmpty(props.serviceOrderVariantId)
      ? {serviceOrderVariantId: props.serviceOrderVariantId}
      : skipToken
  );

  const isXentryAdditionalInformationVisible =
    isNotNilOrEmpty(props.orderId) &&
    !!isDaimlerXentryIntegrationEnabled &&
    !isNil(serviceOrderVariantIntegration) &&
    !serviceOrderVariantIntegration.isExcludedFromXentrySynchronization;

  // The segment lives in a query param shared by every job card, so a hidden segment must not stay selected.
  const currentSegment =
    props.requestedSegment === JobSegments.ADDITIONAL_INFORMATION &&
    !isXentryAdditionalInformationVisible
      ? JobSegments.WORK_ITEMS
      : props.requestedSegment;

  return {isXentryAdditionalInformationVisible, currentSegment};
}
